import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SocialShareWidget } from "@/components/SocialShareWidget";
import { SEO } from "@/components/seo/SEO";
import ContactSection from "@/components/ui/contact-section";
import { useScrollTracking } from "@/hooks/useScrollTracking";

export default function Contact() {
  useScrollTracking();

  return (
    <>
      <SEO
        title="Contact SOL-VI | Direct Contact met Zonne-energie Experts"
        description="Neem contact op voor gratis advies over zonnepanelen, warmtepompen en thuisbatterijen. Bel direct: 06 17 10 57 86 of plan een gratis adviesgesprek."
        type="website"
      />
      <Header />
      
      <main className="min-h-screen">
        <ContactSection />
        
        <div className="container mx-auto px-4 py-8">
          <SocialShareWidget 
            title="Contact SOL-VI - Direct contact met duurzame energie experts"
            description="Neem contact op voor gratis advies over zonnepanelen, warmtepompen en thuisbatterijen. Binnen 2 uur reactie gegarandeerd."
            variant="follow"
            size="lg"
          />
        </div>
      </main>
      
      <Footer />
    </>
  );
}